import { Text } from 'src/Components'

export const MlsDisclaimers = () => {
  return (
    <>
      <Text variant='neutralCool' variantCount='900'>
        This is the disclaimers page
      </Text>
      <Text variant='neutralCool' variantCount='900'>
        Stuff and things
      </Text>
    </>
  )
}
